import { useEffect, useRef } from "react";
import "./App.css";
import CustomLayoutWithMarquee from "./Cctv";
import Slideshow from "./Slideshow";
import EventCalendar from "./EventCalendar";
import NoticeBoard from "./NoticeBoard";
import GurbaniDisplay from "./GurbaniDisplay";
import HukamnamaDisplay from "./HukamnamaDisplay";
import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./ProtectedRoute";
import Login from "./Login";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { WebSocketProvider } from "./contexts/WebSocketProvider";
import { DataProvider } from "./contexts/DataProvider";

function App() {
  const wasOffline = useRef(false);

  useEffect(() => {
    const checkConnection = async () => {
      try {
        // Try pinging a lightweight endpoint
        const response = await fetch("https://www.google.com/favicon.ico", { method: "HEAD", mode: "no-cors" });
        if (wasOffline.current) {
          window.location.reload();
        }
        wasOffline.current = false;
      } catch (err) {
        wasOffline.current = true;
      }
    };

    const interval = setInterval(() => {
      checkConnection();
    }, 3000); // Check every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <WebSocketProvider>
          <DataProvider>
            <Router>
              <Routes>
                <Route path="/login" element={<Login />} />
                {/* Public display routes - no auth required */}
                <Route path="/" element={<CustomLayoutWithMarquee />} />
                <Route path="/slideshow" element={<Slideshow />} />
                <Route path="/calendar" element={<EventCalendar />} />
                <Route path="/noticeboard" element={<NoticeBoard />} />
                <Route path="/gurbani" element={<GurbaniDisplay />} />
                <Route path="/hukamnama" element={<HukamnamaDisplay />} />
              </Routes>
            </Router>
          </DataProvider>
        </WebSocketProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
